import React, { useState } from "react";
import PopupModal from "../../../atoms/popup-modal";
import { object, array, func } from "prop-types";
import { getActivePlans } from "../../../utils/utils";
import { cancelSubscription } from "../../../helper/access-type";
import { submitFeedbackData } from "../../../helper/api";
import Button from "../../../atoms/button";

import "./cancel-subscription.m.css";

const CancelSubscription = ({ member, myPlans, updatePlans, setLoading }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [text, setText] = useState("");
  const [msg, setmsg] = useState("");
  const activePlans = getActivePlans(myPlans);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    cancelSubscription(activePlans[0].id)
      .then((data) => {
        return submitFeedbackData(member, text).then(() => {
          setLoading(false);
          setmsg("Your subscription is being cancelled. thanks for your feedback.");
          updatePlans();
        });
      })
      .catch((e) => {
        setLoading(false);
        setmsg("Something went wrong plase try after some time");
        console.log("error:", e);
      });
  };

  const updateFeedBackText = (e) => setText(e.target.value);

  const handleCancelClick = () => {
    if (!activePlans.length) return;
    setShowPopup(true);
    setmsg("");
  };

  return (
    <React.Fragment>
      <div styleName="cancel-description">
        If you wish to cancel your membership, <span onClick={handleCancelClick}>click here.</span>
      </div>
      {showPopup ? (
        <PopupModal closePopup={() => setShowPopup(false)}>
          <div styleName="wrapper">
            <h2 styleName="title">{msg.length ? msg : "We’re sorry to see you go."}</h2>
            {!msg.length && (
              <textarea
                styleName="text-area"
                name="MultiLine"
                rows="6"
                value={text}
                placeholder="Please help us understand what went wrong."
                onChange={updateFeedBackText}
              />
            )}
            {!msg.length && (
              <div styleName="popup-button-wrapper">
                <Button content="Go Back" buttonType="type1" onClick={() => setShowPopup(false)} />
                <Button content="Cancel Now" buttonType="type2" onClick={handleSubmit} disabled={!text.length} />
              </div>
            )}
          </div>
        </PopupModal>
      ) : null}
    </React.Fragment>
  );
};

CancelSubscription.propTypes = {
  member: object,
  myPlans: array,
  updatePlans: func,
  setLoading: func,
};

export default CancelSubscription;
